import { Component, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideBadgeCheck } from '@ng-icons/lucide';
import { HlmIconImports } from '@spartan-ng/helm/icon';

import { Étape } from '../../../référentiel-métier-parcours/models/étape.model';

@Component({
  selector: 'app-resume-etape',
  imports: [HlmIconImports],
  templateUrl: './resume-etape.component.html',
  providers: [provideIcons({ lucideBadgeCheck })],
})
export class ResumeEtapeComponent {
  readonly etape = input.required<Étape>();
}
